import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPosition = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 42,
	height: 32,
	viewBox: "0 0 42 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M16.255 3.5c-1.087 0-1.949.985-1.949 2.19l-.01 15.324c0 1.205.872 2.19 1.96 2.19h13.711c1.077 0 1.959-.985 1.959-2.19V5.69c0-1.204-.882-2.189-1.959-2.189H16.255zm13.712 17.514H16.255V7.648h13.712v13.366zm-2.932 5.82V24.24l5.928 3.63-5.928 3.629v-2.593H14.296v-2.074h12.74zM8.593 10.518H6l3.63-5.982 3.63 5.982h-2.593v12.685H8.593V10.519z" })
	})
});
export default SvgPosition;
